import React from 'react';
import { Helmet } from 'react-helmet';

var Head = function Head(props) {
  var utagConfigLoader = props.utagConfig ? "JSON.parse(".concat(JSON.stringify(JSON.stringify(props.utagConfig)), ")") : 'window.pibOptions';
  var Helmet$1 = props.helmet || Helmet;
  return React.createElement(Helmet$1, null, !props['no-html'] && React.createElement("html", {
    lang: "en",
    dir: "ltr"
  }), (props.title || props.pageName) && React.createElement("title", null, props.title || props.pageName), !props['no-favicon'] && [React.createElement("link", {
    key: "apple-touch-icon:60x60",
    rel: "apple-touch-icon",
    sizes: "60x60",
    href: "https://www.politico.com/apple-touch-icon-60x60.png"
  }), React.createElement("link", {
    key: "apple-touch-icon:72x72",
    rel: "apple-touch-icon",
    sizes: "72x72",
    href: "https://www.politico.com/apple-touch-icon-72x72.png"
  }), React.createElement("link", {
    key: "apple-touch-icon:76x76",
    rel: "apple-touch-icon",
    sizes: "76x76",
    href: "https://www.politico.com/apple-touch-icon-76x76.png"
  }), React.createElement("link", {
    key: "apple-touch-icon:114x114",
    rel: "apple-touch-icon",
    sizes: "114x114",
    href: "https://www.politico.com/apple-touch-icon-114x114.png"
  }), React.createElement("link", {
    key: "apple-touch-icon:120x120",
    rel: "apple-touch-icon",
    sizes: "120x120",
    href: "https://www.politico.com/apple-touch-icon-120x120.png"
  }), React.createElement("link", {
    key: "apple-touch-icon:144x144",
    rel: "apple-touch-icon",
    sizes: "144x144",
    href: "https://www.politico.com/apple-touch-icon-144x144.png"
  }), React.createElement("link", {
    key: "apple-touch-icon:152x152",
    rel: "apple-touch-icon",
    sizes: "152x152",
    href: "https://www.politico.com/apple-touch-icon-152x152.png"
  }), React.createElement("link", {
    key: "apple-touch-icon:180x180",
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: "https://www.politico.com/apple-touch-icon-180x180.png"
  }), React.createElement("link", {
    key: "icon:32x32",
    rel: "icon",
    sizes: "32x32",
    type: "image/png",
    href: "https://www.politico.com/favicon-32x32.png"
  }), React.createElement("link", {
    key: "icon:192x192",
    rel: "icon",
    sizes: "192x192",
    type: "image/png",
    href: "https://www.politico.com/android-chrome-192x192.png"
  }), React.createElement("link", {
    key: "icon:96x96",
    rel: "icon",
    sizes: "96x96",
    type: "image/png",
    href: "https://www.politico.com/favicon-96x96.png"
  }), React.createElement("link", {
    key: "icon:16x16",
    rel: "icon",
    sizes: "16x16",
    type: "image/png",
    href: "https://www.politico.com/favicon-16x16.png"
  })], !props['no-meta'] && [React.createElement("meta", {
    key: "charSet",
    charSet: "utf-8"
  }), React.createElement("meta", {
    key: "httpEquiv='Content-Type'",
    httpEquiv: "Content-Type",
    content: "text/html; charset=UTF-8"
  }), React.createElement("meta", {
    key: "httpEquiv='X-UA-Compatible'",
    httpEquiv: "X-UA-Compatible",
    content: "IE=edge,chrome=1"
  }), React.createElement("meta", {
    key: "viewport",
    name: "viewport",
    content: "width=device-width, initial-scale=1"
  })], props.publishPath && !props['no-canonical'] && [React.createElement("meta", {
    key: "og:url",
    property: "og:url",
    content: "https://politico.com/".concat(props.publishPath)
  }), React.createElement("link", {
    key: "canonical",
    rel: "canonical",
    href: "https://politico.com/".concat(props.publishPath)
  })], props.social && [React.createElement("meta", {
    key: "description",
    name: "description",
    content: props.social.twitter.card_description
  }), React.createElement("meta", {
    key: "twitter:card",
    property: "twitter:card",
    content: "summary_large_image"
  }), React.createElement("meta", {
    key: "og:type",
    property: "og:type",
    content: "article"
  }), React.createElement("meta", {
    property: "article:opinion",
    content: props.opinion
  }), React.createElement("meta", {
    key: "twitter:site",
    property: "twitter:site",
    content: "@politico"
  }), React.createElement("meta", {
    key: "twitter:creator",
    property: "twitter:creator",
    content: "@politico"
  }), React.createElement("meta", {
    key: "article:author",
    property: "article:author",
    content: "https://www.facebook.com/politico"
  }), React.createElement("meta", {
    key: "fb:app_id",
    property: "fb:app_id",
    content: "114037015331397"
  }), React.createElement("meta", {
    key: "twitter:title",
    property: "twitter:title",
    content: props.social.twitter.card_title
  }), React.createElement("meta", {
    key: "og:title",
    property: "og:title",
    content: props.social.fbook.card_title
  }), React.createElement("meta", {
    key: "twitter:description",
    property: "twitter:description",
    content: props.social.twitter.card_description
  }), React.createElement("meta", {
    key: "og:description",
    property: "og:description",
    content: props.social.fbook.card_description
  }), React.createElement("meta", {
    key: "twitter:image",
    property: "twitter:image",
    content: props.social.image.url
  }), React.createElement("meta", {
    key: "twitter:image:alt",
    property: "twitter:image:alt",
    content: props.social.twitter.card_title
  }), React.createElement("meta", {
    key: "og:image",
    property: "og:image",
    content: props.social.image.url
  }), React.createElement("meta", {
    key: "og:image:type",
    property: "og:image:type",
    content: props.social.image.type
  }), React.createElement("meta", {
    key: "og:image:width",
    property: "og:image:width",
    content: props.social.image.width
  }), React.createElement("meta", {
    key: "og:image:height",
    property: "og:image:height",
    content: props.social.image.height
  })], !props['no-battletoads'] && React.createElement("link", {
    key: "battletoads",
    rel: "stylesheet",
    type: "text/css",
    href: "https://www.politico.com/interactives/cdn/fonts/battletoads/icons/politico-battletoads-icons.min.css"
  }), !props['no-fontawesome'] && React.createElement("link", {
    key: "fontawesome",
    rel: "stylesheet",
    href: "https://use.fontawesome.com/releases/v5.3.1/css/all.css",
    integrity: "sha384-mzrmE5qonljUremFsqc01SB46JvROS7bZs3IO2EmfFsd15uHvIt+Y8vEf7N7fWAU",
    crossOrigin: "anonymous"
  }), !props['no-typekit'] && props['site'] === 'magazine' && [React.createElement("link", {
    key: "jubilat",
    rel: "stylesheet",
    href: "https://use.typekit.net/bvr3gvp.css"
  })], !props['no-typekit'] && [React.createElement("link", {
    key: "typekit",
    rel: "stylesheet",
    href: "https://use.typekit.net/dsx2uhv.css"
  }), React.createElement("script", {
    key: "typekit-script"
  }, "try{Typekit.load({ async: true });}catch(e){}")], !props['no-jQuery'] && React.createElement("script", {
    src: "https://code.jquery.com/jquery-3.2.1.slim.min.js",
    integrity: "sha256-k2WSCIexGzOj3Euiig+TlR8gA0EmPjuc79OEeY5L45g=",
    crossOrigin: "anonymous"
  }), !props['no-adBlockCookie'] && React.createElement("script", null, "document.cookie=\"__adblocker=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/\";var setNptTechAdblockerCookie=function(adblocker){var d=new Date();d.setTime(d.getTime()+60*60*24*2*1000);document.cookie=\"__adblocker=\"+(adblocker?\"true\":\"false\")+\"; expires=\"+d.toUTCString()+\"; path=/\"};var script=document.createElement(\"script\");script.setAttribute(\"async\",true);script.setAttribute(\"src\",\"//www.npttech.com/advertising.js\");script.setAttribute(\"onerror\",\"setNptTechAdblockerCookie(true);\");document.getElementsByTagName(\"head\")[0].appendChild(script);"), !props['no-utag'] && React.createElement("script", null, "// UTag Setup Script\n\n            function get(obj,key,def){if(obj.hasOwnProperty(key)){return obj[key]}else{return def}}\n            function makeBylines(authors){if(authors.length===1){return authors[0]}else if(authors.length===0){return null}var output=authors.slice();var lastAuthor=output.pop();var secondToLastAuthor=output.pop();var commaAuthors=output.length>0?output.join(', ')+', ':'';return commaAuthors+secondToLastAuthor+' and '+lastAuthor}\n            function setupUtag(){var conf=".concat(utagConfigLoader, ";if(!conf){return}const authors=get(conf,'authors',[]).map(function(a){if(typeof a==='string'){return a}else if(typeof a==='object'&&'name'in a){return a.name}else{return ''}});\n\n            // Set up utag variables from project package.json\n            if(").concat(props.utagOverride && props.utagOverride === true, "){window.utag_data=JSON.parse(").concat(JSON.stringify(JSON.stringify(props.utagConfig)), ")}else{window.utag_data={'page_level_1':'interactives','free_paid_content':get(conf,'freePaidContent',null),'ad_unit_section':get(conf,'adUnitSection',null),'site_section':get(conf,'siteSection',null),'page_type':get(conf,'pageType',null),'site_domain':'www.politico.com','internal_site_id':'politico','page_name':get(conf,'pageName',null),'content_author':authors.join('|'),'content_byline':'By '+makeBylines(authors),'enable_prebid':true}}\n\n            // load the utag script\n            (function(a,b,c,d){a='//tags.tiqcdn.com/utag/politico/main/prod/utag.js';b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a)})();\n\n            // responsive ad script\n            !(function (a) { var b = function () { var a = document.createElement('p'); a.style.width = '100%', a.style.height = '200px'; var b = document.createElement('div'); b.style.position = 'absolute', b.style.top = '0px', b.style.left = '0px', b.style.visibility = 'hidden', b.style.width = '200px', b.style.height = '150px', b.style.overflow = 'hidden', b.appendChild(a), document.body.appendChild(b); var c = a.offsetWidth; b.style.overflow = 'scroll'; var d = a.offsetWidth; return c === d && (d = b.clientWidth), document.body.removeChild(b), c - d; }; var c = function () { typeof googletag !== 'undefined' && googletag.cmd.push(function () { googletag.pubads().refresh(); }); }; var d = function () { var a = 'alpha'; return i >= 748 && i < 990 ? a = 'beta' : i >= 990 && i < l ? a = 'gamma' : i >= l && i < 1028 ? a = 'delta' : i >= 1028 && (a = 'epsilon'), a != 'epsilon' && a != 'delta' && (jQuery('.global-utility-bar .reveal-toggle .reveal').removeClass('is-active'), jQuery('.utility-bar-bottom').removeClass('is-active'), jQuery('.dynamic-ad-wrapper .ad-slot').remove(), jQuery('.global-utility-bar .dynamic-ad-wrapper').html('')), a; }; var e = {currentAdThreshold: ''}; var f = function () { var a = d(); e.currentAdThreshold !== a && (e.currentAdThreshold = a, c()); }; var g = function () { e.currentAdThreshold = d(); }; a(window).on('resize', function () { i = document.documentElement.clientWidth + h, f(); }); var h = b(); var i = document.documentElement.clientWidth + h; var l = 1012; g(); }(jQuery));};\n\n            function loadUtag(){var loadMax=5000;var loadCount=0;var loadInterval=300;var utagLoader=window.setInterval(function(){if(window.jQuery){setupUtag();window.clearInterval(utagLoader)}else{loadCount=loadCount+1}if(loadCount*loadInterval>loadMax){window.clearInterval(utagLoader)}},loadInterval)}\n\n            // Cross-Browser Ready Script\n            if(document.attachEvent?document.readyState==='complete':document.readyState!=='loading'){loadUtag()}else{document.addEventListener('DOMContentLoaded',loadUtag)}\n\n            // Ad Fix Code\n            var gptadslots=[];var googletag=googletag||{};googletag.cmd=googletag.cmd||[];(function(){var gads=document.createElement('script');gads.async=true;gads.type='text/javascript';var useSSL='https:'==document.location.protocol;gads.src=(useSSL?'https:':'http:')+'//securepubads.g.doubleclick.net/tag/js/gpt.js';var node=document.getElementsByTagName('script')[0];node.parentNode.insertBefore(gads,node)})();\n          ")), props.children);
};

Head.defaultProps = {
  title: null,
  publishPath: null,
  social: null,
  opinion: false,
  utagConfig: null,
  helmet: null,
  site: 'core',
  'no-html': false,
  'no-title': false,
  'no-favicon': false,
  'no-canonical': false,
  'no-meta': false,
  'no-social': false,
  'no-battletoads': false,
  'no-fontawesome': false,
  'no-typekit': false,
  'no-jquery': false,
  'no-adBlockCookie': false,
  'no-utag': false
};

export default Head;
